import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import ResourcesInfo from 'components/ResourcesDialogInfo';
import LightningIcon from 'assets/icons/daily/icon-park-twotone_lightning.svg?react';
import FireIcon from 'assets/icons/daily/fluent-emoji-flat_fire.svg?react';
import CoinIcon from 'assets/icons/daily/coin.svg?react';

import { Info } from 'lucide-react';

const FireIconStyled = styled(FireIcon)(() => ({
  width: 20,
  height: 20
}));

const CoinIconStyled = styled(CoinIcon)(() => ({
  width: 20,
  height: 20
}));

const LightningIconStyled = styled(LightningIcon)(() => ({
  width: 20,
  height: 20
}));

const InfoIconStyled = styled(Info)(({ theme }) => ({
  width: 18,
  height: 18,
  stroke: `${theme.palette.grey[200]} !important`,
  fill: 'none !important',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  color: theme.palette.grey[200],
  '& path': {
    fill: 'none !important',
    stroke: `${theme.palette.grey[200]} !important`
  },
  '& circle': {
    fill: 'none !important',
    stroke: `${theme.palette.grey[200]} !important`
  }
}));

const Resources = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginRight: 25,
  marginLeft: 25,
  [theme.breakpoints.down('md')]: {
    paddingLeft: 20,
    paddingRight: 20,
    marginRight: 0,
    marginLeft: 0,
    gap: 20
  }
}));

const ResourcesItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10
}));

const ResourcesText = styled(Typography)(({ theme, mobile, transparent }) => ({
  color: transparent 
    ? theme.palette.textPrimary.main 
    : (mobile === 'true' ? theme.palette.textPrimary.main : theme.palette.white.main),
  fontSize: 14,
  width: 45,
  [theme.breakpoints.down('md')]: {
    width: 'unset'
  }
}));

const InfoWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer'
}));

const RenderResources = ({ transparent }) => {
  const t = useTranslate('Header');
  const [open, setOpen] = React.useState(false);
  const XP = useSelector((state) => state.gamification.dailyQuest);
  const balance = useSelector((state) => state.gamification.balance);
  const isMobile = useSelector((state) => state.app.isMobile);

  return (
    <Resources>
      <ResourcesItem>
        <FireIconStyled style={transparent ? { fill: 'currentColor' } : {}} />
        <ResourcesText mobile={`${isMobile}`} transparent={transparent}>
          {balance?.dailyQuestMarathon || t('DaysPlaceholder')}
        </ResourcesText>
      </ResourcesItem>
      <ResourcesItem>
        <CoinIconStyled style={transparent ? { fill: 'currentColor' } : {}} />
        <ResourcesText mobile={`${isMobile}`} transparent={transparent}>
          {balance?.currencyBalance || t('TrollarsPlaceholder')}
        </ResourcesText>
      </ResourcesItem>
      <ResourcesItem>
        <LightningIconStyled style={transparent ? { fill: 'currentColor' } : {}} />
        <ResourcesText mobile={`${isMobile}`} transparent={transparent}>
          {XP?.totalPoints || t('PointsPlaceholder')}
        </ResourcesText>
      </ResourcesItem>
      <InfoWrapper
        onClick={() => {
          setOpen(true);
          import('services/analytics').then((Analytics) => {
            Analytics.default.event('GamificationInfoClick');
          });
        }}>
        <InfoIconStyled />
      </InfoWrapper>
      <ResourcesInfo open={open} onClose={() => setOpen(false)} />
    </Resources>
  );
};

export default RenderResources;
